$(document).ready(function(){$(".js-pollVote").on("click",function(o){var t=$("input:radio[name=poll]:checked").val();void 0==t?alert("We hebben geen stem van je ontvangen."):$.post("/requests/",{pollQuestionID:$("#pollQuestionID").val(),poll:t}).done(function(o){$("#pollQuestion").html(o)}),o.preventDefault()})}),$(window).load(function(){if($("#sticker").length){var o=$("#sticker"),t=o.position(),e=$(document).outerHeight()-$("#footer").outerHeight()-o.outerHeight()-135;$(window).scroll(function(){var i=$(window).scrollTop();i>=t.top&&e>i?(o.attr("style",""),o.addClass("stick")):i>=e?(o.removeClass("stick"),o.css({position:"absolute",top:e+"px"})):o.removeClass("stick")})}}),$(window).load(function(){if($("#sticker2").length){var o=$("#sticker2"),t=o.position(),e=$(document).outerHeight()-$("#footer").outerHeight()-o.outerHeight()-135;$(window).scroll(function(){var i=$(window).scrollTop();i>=t.top&&e>i?(o.attr("style",""),o.addClass("stick")):i>=e?(o.removeClass("stick"),o.css({position:"absolute",top:e+"px"})):o.removeClass("stick")})}});$(document).ready(function() {
    var consentIsSet = "unknown";
    var cookieBanner = "#cookieBanner";
    var consentString = "cookieConsent=";
    function setCookie(console_log, banner_text, consent) {
        $(cookieBanner).fadeOut();
        var d = new Date();
        var exdays = 30*12; //  1 year
        d.setTime(d.getTime()+(exdays*24*60*60*1000));
        var expires = "expires="+d.toGMTString();
        document.cookie = consentString + consent + "; " + expires + ";path=/";
        consentIsSet = consent;
    }
    function grantConsent() {
        if (consentIsSet == "true") return; 
        setCookie("Consent granted", "Bedankt voor het accepteren van cookies.", "true");
    }
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var c = cookies[i].trim();
        if (c.indexOf(consentString) == 0) {
            consentIsSet = c.substring(consentString.length, c.length);
        }
    }
    if (consentIsSet == "unknown") {    
        $(cookieBanner).fadeIn();
        var pageName = location.pathname.substr(location.pathname.lastIndexOf("/") + 1);
		  $(document).on('click','.allowConsent', function(e) {
		  	grantConsent();
		  return false;
		});
    } 
});